import React, { useState } from 'react';
import classnames from 'classnames';
import { useAppDispatch } from '@nutastic/nutastic-react-app';
import { sendOrderSubmission } from '../state/actions.mjs';

const defaultFormValues = {
    name: '',
    phone: '',
    email: '',
    orderDetails: ''
};

// eslint-disable-next-line react/prop-types
const OrderRequestForm = ({ type, onComplete }) => {
    const componentClass = 'orderRequestForm';
    const classes = classnames(componentClass, 'form-content');
    const [formValues, setFormValues] = useState(defaultFormValues);
    const appDispatch = useAppDispatch();

    const onFieldChange = (key, value) => {
        setFormValues({
            ...formValues,
            [key]: value
        });
    };

    const onFormSubmit = e => {
        e.preventDefault();
        appDispatch(sendOrderSubmission({
            ...formValues,
            type
        }));
        onComplete();
    };

    return <form onSubmit={onFormSubmit} className={classes}>
        <h1>Place an Order Request</h1>
        <p>Fill out the fields below to submit your order request. We will get back to you ASAP with a quote and / or reach out to your to discuss more.</p>
        <hr />
        <fieldset>
            <div className="twoFields">
                <div>
                    <label>Full Name:</label>
                    <input type="text" className="form-control" placeholder="Full Name" value={formValues.name} onChange={e => onFieldChange('name', e.target.value)}/>
                </div>
                <div>
                    <label>Phone Number:</label>
                    <input type="text" className="form-control" placeholder="Last Name" value={formValues.phone} onChange={e => onFieldChange('phone', e.target.value)}/>
                </div>
            </div>
            <div className="twoFields">
                <div>
                    <label>Email:</label>
                    <input type="email" className="form-control" placeholder="Email Address" value={formValues.email} onChange={e => onFieldChange('email', e.target.value)}/>
                </div>
                <div><label>Order Type:</label>
                    <input type="text" name="orderType" className="form-control" value={type} disabled={true}/>
                </div>
            </div>
            <div className="textAreaField">
                <label>Order Details:</label>
                <span>Describe the details about what you would like to order.</span>
                <textarea placeholder="Order Details" className="form-control" rows="5" value={formValues.orderDetails} onChange={e => onFieldChange('orderDetails', e.target.value)} />
            </div>
            <button type="submit" className="btn btn-primary">Submit Order Request</button>
        </fieldset>
        <small>Make sure to enter a valid email and / or phone number. We will contact you to discuss any details about order and provide you with a quote.</small>
    </form>;
};

export default OrderRequestForm;
